import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TemplateSearchCar } from 'src/app/app.models';
import { LitigeService } from 'src/app/services/litige.service';
import { SinistreService } from 'src/app/services/sinistre.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { CarIn } from '../mes-vehicules/cars/cars-dialog/car-in';
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { AppService } from 'src/app/app.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { LoginserviceService } from 'src/app/services/loginservice.service';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';

@Component({
  selector: "app-litige",
  templateUrl: "./litige.component.html",
  styleUrls: ["./litige.component.scss"],
})
export class LitigeComponent implements OnInit {
  public minDateStart: Date;
  public minDateEnd: Date;
  public currentDateStart?: string;
  public currentDateEnd?: string;
  public showChoice: boolean;
  public showChoiceEnd: boolean;
  public errorAdress: boolean;
  public valueDatePickerEnd?: Date;
  public userIn: any;

  dateStart: any;
  dateEnd: any;
  todayWithPipe: any;
  periodStart?: string;
  periodEnd?: string;
  currentDateFormat?: string;
  templateSearchCar: TemplateSearchCar;

  index: number;
  displayedColumns: string[] = [
    "id",
    "marque",
    "model",
    // "prix",
    "date",
   
    // "actions",
    "desc",
    "status",
  ];
  user: any = [];
  customerList: any;
  resultcat: any;
  idcar: number;
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  public stores = [
    { id: 1, name: "Store 1" },
    { id: 2, name: "Store 2" },
  ];
  result: {
    id: any;
    vehicle_mileage: any;
    vehicle_price_location: any;
    created_at: any;
    status: string;
  };
  datest: any[] | undefined;
  displayStatus: boolean;

  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;

  constructor(
    public appService: AppService,
    public appServices: UserServiceService,
    public snackBar: MatSnackBar,
    public carservice: VehiculeserviceService,
    public loginService: LoginserviceService,
    public litigeservice: LitigeService,
    public router: Router,
    public toast :ToastrService,
    private verifResponsiveService:VerifResponsiveService

  ) {}
  ngOnInit() {
    this.getLitige();
    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      this.viewType = data ? 'grid' : 'list';
    });
  }
  
  public getLitige() {
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    } else {
      this.router.navigate(['login']);
    }

    this.litigeservice.getLitige(this.userIn.id).subscribe((data: any) => {
      this.resultcat = data;
      this.idcar = data.id;
      this.dataSource = new MatTableDataSource<any>(this.resultcat);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  public remove(id: number) {
    this.carservice.suprimeCar(id).subscribe((data) => {
      this.getLitige();
    });
  }

  public edit(id: number) {
    this.router.navigate(["compte-utilisateur/ajoute-litige"], {
      queryParams: { code: id },
    });
  }

  public openCustomerDialog(customer: any) {
    let data = {
      customer: customer,
      stores: this.stores,
      user: this.user,
    };
  }

  changeStatus(id:number,status:string)
  {
    this.litigeservice.updateStatutLitige(id,status).subscribe((resp:any)=>{
      this.getLitige();
      this.toast.success(resp.message,'Succès');
    },error=>{
      this.toast.error("Une erreur s'est produite veillez réessayer",'Erreur');
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }  

   
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

  refresh() {
    //window.location.reload();
   //location.reload();
    this.getLitige();
    
  }
}
